import __variableDynamicImportRuntimeHelper from "../../_virtual/dynamic-import-helper.es.js";
import i18next from "i18next";
let loadProjectLanguage = async (_lang) => ({});
let languages = [];
function useI18n() {
  return {
    setLang: async (lang) => {
      await loadLanguage(lang);
      i18next.changeLanguage(lang);
    },
    getLang: () => i18next.language,
    getLanguages: () => i18next.languages,
    t: translateWithFallback,
    i18next
  };
}
async function setupI18n(opt) {
  if (opt.loadLanguage) {
    loadProjectLanguage = opt.loadLanguage;
  }
  languages = opt.supportedLanguages;
  await i18next.init({
    lng: opt.language,
    supportedLngs: opt.supportedLanguages,
    fallbackLng: ["en-US", "en-SE"],
    lowerCaseLng: false,
    defaultNS: opt.defaultNS,
    returnNull: true,
    ns: ["app", "uikit"],
    debug: !!opt.debug,
    interpolation: {
      prefix: "{",
      suffix: "}"
    }
  });
  if (opt.waitForLanguageLoad) {
    await loadLanguage(opt.language);
  } else {
    loadLanguage(opt.language);
  }
  return i18next;
}
function translateWithFallback(key, values) {
  const exact = i18next.t(key, values);
  if (exact !== key) {
    return exact;
  }
  console.error(`i18next: Missing translation for key: ${key}`);
  return i18next.t(key, { ...values, lng: "source" }) || key;
}
function loadLanguage(lang) {
  return Promise.all([
    loadAndSetProjectLanguage(lang),
    loadAndSetUikitLanguage(lang)
  ]);
}
async function loadAndSetProjectLanguage(lang) {
  const resources = await loadProjectLanguage(lang);
  i18next.addResourceBundle(lang, "app", resources, true, true);
}
async function loadAndSetUikitLanguage(lang) {
  const resources = await __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./translations/wsk.cs-CZ.json": () => import("./translations/wsk.cs-CZ.json.es.js"), "./translations/wsk.en-SE.json": () => import("./translations/wsk.en-SE.json.es.js"), "./translations/wsk.en-US.json": () => import("./translations/wsk.en-US.json.es.js"), "./translations/wsk.hu-HU.json": () => import("./translations/wsk.hu-HU.json.es.js"), "./translations/wsk.sk-SK.json": () => import("./translations/wsk.sk-SK.json.es.js"), "./translations/wsk.sv-SE.json": () => import("./translations/wsk.sv-SE.json.es.js"), "./translations/wsk.xx-XX.json": () => import("./translations/wsk.xx-XX.json.es.js") }), `./translations/wsk.${lang}.json`, 3);
  i18next.addResourceBundle(lang, "uikit", resources["wsk"], true, true);
}
export {
  languages,
  setupI18n,
  useI18n
};
//# sourceMappingURL=i18n.es.js.map
